import { render, staticRenderFns } from "./VLangSelect.vue?vue&type=template&id=c0598e70&scoped=true&"
import script from "./VLangSelect.vue?vue&type=script&lang=js&"
export * from "./VLangSelect.vue?vue&type=script&lang=js&"
import style0 from "./VLangSelect.vue?vue&type=style&index=0&id=c0598e70&lang=scss&scoped=true&"
import style1 from "./VLangSelect.vue?vue&type=style&index=1&id=c0598e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0598e70",
  null
  
)

export default component.exports